<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{'Frontend Settings'}}</strong>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- <vue-tabs v-model="selTab" direction="horizontal" @tab-change="getTabData">
      <v-tab :title="alg.name" v-for="(alg, index) in tabs" v-bind:key="index">-->
      <div class="row mb-15">
        <div class="col-md-12">
          <h4 class="title">Default company to show for free users</h4>
        </div>
      </div>
      <div class="row mb-15">
        <div class="col-md-6">
          <div class="form-group">
            <v-select
              :options="companyList"
              :placeholder="'Select Company'"
              :label="'companyname'"
              v-model="selComp"
            >
              <!-- <div class="spinner" v-show="spinner">Loading...</div> -->
            </v-select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="col-form-label"></label>
            <button type="button" class="btn btn-primary" @click="update()">Update</button>
          </div>
        </div>
      </div>
      <!-- </v-tab>
      </vue-tabs>-->
    </div>
    <PinCheck
      :show.sync="show"
      ref="smallModal"
      v-bind:small="true"
      @submitForm="updateCompany"
      :cancelClass="'btn btn-secondary'"
    ></PinCheck>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
import PinCheck from "@/components/PinCheck.vue";
export default {
  components: { PinCheck },
  mixins: [commonMixins],
  created() {
    this.getCompaniesList();
  },
  data() {
    return {
      show: false,
      companyList: [],
      selComp: "",
      company: { co_code: "", companyname: "" }
    };
  },
  methods: {
    getCompaniesList() {
      let _this = this;
      http.get("getCompanyMaster", {}, function(error, response) {
        var companyList = response;
        if (companyList.length > 0) {
          _this.companyList = _this.sorted_fields_asc(
            companyList,
            "companyname"
          );
          _this.getDefaultCompany();
        }
      });
    },
    getDefaultCompany() {
      //get/settings
      http.get("get/settings", {}, (error, response) => {
        console.log(error, response);
        if (!error) {
          if (response.length) {
            this.selComp = response[0];
          }
        }
      });
    },
    update() {
      if (this.selComp !== "") {
        this.$refs.smallModal.open();
      }
    },
    updateCompany() {
      //update/settings
      http.post("update/settings", this.selComp, (error, response) => {
        console.log(error, response);
        if (response.responseType === "Success") {
          this.$toastr.success(response.message, {}, "");
        } else {
          this.$toastr.error(response.message, {}, "");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/settings/frontend.vue